import 'react-toastify/dist/ReactToastify.css';

import * as yup from "yup";

import {
  Avatar,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Paper,
  Slide,
  Stack,
  TextField,
  Tooltip,
  Typography
} from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import React, { useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import { cyan, red } from "@mui/material/colors";
import {
  useAddNewExpertiseMutation,
  useDeleteExpertiseMutation,
  useEditCvExpertiseMutation
} from "../../../lib/cvsSlice";

import AddIcon from "@mui/icons-material/Add";
import CancelIcon from "@mui/icons-material/Cancel";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";
import Select from "react-select";
import StarsIcon from "@mui/icons-material/Stars";
import { areasOfExpertise } from "config";
import useFormPersist from "react-hook-form-persist";
import { yupResolver } from "@hookform/resolvers/yup";

const cvSchema = yup.object().shape({
  expertise: yup.array().required("Expertise is required"),
  otherExpertise: yup.string(),
});

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const Expertise = ({ expertise, cvId, label }) => {
  const [open, setOpen] = useState(false);
  const [mode, setMode] = useState();
  const [expertiseId, setExpertiseId] = useState()
  const [expertiseState, setExpertiseState] = useState([expertise]);
  const [expertisee, setExpertisee] = useState([]);
  const [selectedExpertise, setSelectedExpertise] = useState([]);
  const [otherExpertise, setOtherExpertise] = useState("");

  const handleOpen = (mode) => {
    setOpen(true);
    setMode(mode);
  };

  const handleClose = () => {
    reset();
    setExpertisee([]);
    setSelectedExpertise([]);
    setOtherExpertise("");
    setOpen(false);
  };

  const {
    handleSubmit,
    control,
    reset,
    watch,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(cvSchema),
    defaultValues: {
      expertise: [],
      otherExpertise: "",
    },
  });

  const [addNewExpertise] = useAddNewExpertiseMutation();

  const submitResults = async (e) => {
    const newExpertise = e;
    await addNewExpertise({ cvId, expertise: [newExpertise] }).unwrap();
    handleClose();
    expertise.push(newExpertise);
    toast.success("Expertise added successfully");
  };

  const [deleteExpertise] = useDeleteExpertiseMutation();

  const handleRemove = async (item) => {
    await deleteExpertise({ cvId, expertiseId: item }).unwrap();
    const updatedExpertise = expertiseState.filter((exp) => exp.id !== item);
    setExpertiseState(updatedExpertise);
    expertise.splice(
      expertise.findIndex((exp) => exp._id === item),
      1
    );
    setExpertisee([...expertise]);
    toast.info("Expertise removed successfully");
  };

  const [editCvExpertise] = useEditCvExpertiseMutation();
  const handleEdit = (expertiseId, mode) => {
    setOpen(true);
    setMode(mode);
    setExpertiseId(expertiseId);
  };

  useFormPersist("expertise", {
    watch,
    reset,
    setValue,
    storage: window.localStorage, // default window.sessionStorage
  });

  const handleOnChange = (selectedOption) => {
    if (selectedOption && selectedOption.length > 10) {
      // Limit the selections to a maximum of 10
      selectedOption = selectedOption.slice(0, 10);
  
      // Show a toast notification about the maximum number of expertise reached
      toast.info('You have reached the maximum number of expertise (10).', {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  
    const selectedValues = selectedOption
      ? selectedOption.map((option) => option.value)
      : [];
  
    setSelectedExpertise(selectedValues);
    setValue('expertise', selectedValues); // update form value
  
    if (selectedValues.includes('other')) {
      // If "Other" option is selected, clear the otherExpertise state
      setOtherExpertise('');
    }
  };
  
  const handleOtherExpertiseChange = (event) => {
    setOtherExpertise(event.target.value);
    localStorage.setItem("otherExpertise", event.target.value);
  };

  useEffect(() => {
    const data = localStorage.getItem(`expertise_${cvId}`);
    if (data !== null) {
      setExpertisee(JSON.parse(data));
    }

    const otherExpertiseData = localStorage.getItem("otherExpertise");
    if (otherExpertiseData !== null) {
      setOtherExpertise(otherExpertiseData);
    }
  }, []);

  const handleInputChange = (event, expertiseId, fieldName) => {
    const updatedExpertise = expertise.map((exp) => {
      if (exp._id === expertiseId) {
        if (fieldName === "expertise") {
          // Convert the event target value to an array of expertise options
          const selectedOptions = event.map((option) => option.value);
          return { ...exp, [fieldName]: selectedOptions };
        }
  
        // Handle other fields here (if any)
      }
      return exp;
    });
  
    setExpertiseState(updatedExpertise);
  };
  
  useEffect(() => {
    localStorage.setItem(`expertise_${cvId}`, JSON.stringify(expertisee));
  }, [expertisee]);

  useEffect(() => {
    localStorage.setItem(`expertise_${cvId}`, JSON.stringify(expertiseState));
  }, [expertiseState]);

  const expertiseElement = expertise.find((exp) => exp._id === expertiseId);
  
  const renderSingleElement = (expertiseId) => {
    return (
      <Grid item xs={12}>
        <Controller
          name={expertise}
          control={control}
          rules={{ required: true }}
          render={({ field: { onChange } }) => {
            return (
              <Select
                error={!!errors.expertise}
                options={areasOfExpertise}
                placeholder="Start typing your expertise"
                noOptionsMessage={() => "The mentioned role isn't available"}
                isClearable
                isMulti
                isSearchable
                fullWidth
                helperText={errors?.expertise ? errors.expertise?.message : ""}
                onChange={(e) => handleInputChange(e, expertiseId, "expertise")}
                value={areasOfExpertise.filter((option) =>
                  expertiseElement.expertise.includes(option.value)
                )}
                styles={{
                  menuPortal: (base) => ({
                    ...base,
                    zIndex: 9999,
                  }),
                }}
                menuPortalTarget={document.body} // Render the menu outside the current DOM hierarchy
              />
            );
          }}
        />
      </Grid>
    );
  };
    
  const submitEditResults = async () => {
    await editCvExpertise({
      cvId,
      expertiseElement,
      expertise: [expertiseElement],
    }).unwrap();
    handleClose();
    toast.info("Education updated successfully");
  };

  return (
    <div id="Expertise">
      <ToastContainer autoClose={1500} />
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Paper style={{ marginTop: "20px", padding: "15px" }}>
            <Grid
              container
              spacing={2}
              justifyContent="center"
              alignItems="center"
              style={{ marginTop: "5px" }}
            >
              <Grid item xs={12}>
                <Grid container spacing={2}>
                  <Grid item xs={9}>
                    <Typography
                      variant="h6"
                      gutterBottom
                      component="div"
                      sx={{ p: 0, pb: 0 }}
                    >
                      Areas of Expertise {" "} &nbsp;
                    </Typography>
                  </Grid>

                  <>
                    <Grid item xs={1}>
                      <Tooltip
                        title="Maximum expertise is 10"
                        placement="bottom"
                      >
                        <IconButton
                          aria-label="add"
                          onClick={() => handleOpen("add")}
                          disabled={expertiseState?.length >= 1 && expertiseState[0]?.length !== 0}
                          color={expertiseState?.length >= 1 && expertiseState[0]?.length !== 0 ? "disabled" : "primary"}
                        >
                          <AddIcon />
                        </IconButton>
                      </Tooltip>
                    </Grid>

                    <Grid item xs={1}>
                      <IconButton
                        aria-label="edit"
                        onClick={() => handleOpen("edit")}
                      >
                        <EditIcon color="primary" />
                      </IconButton>
                    </Grid>
                  </>

                </Grid>
              </Grid>
              <Grid item xs={12}>
                {expertise?.map((exp) => (
                  <List key={exp._id} style={{ padding: "0px" }}>
                    <ListItem>
                      <ListItemAvatar>
                        <Avatar style={{ backgroundColor: cyan[700] }}>
                          <StarsIcon />
                        </Avatar>
                      </ListItemAvatar>
                      <ListItemText
                        style={{ paddingLeft: "10px" }}
                        primary={
                          <Typography variant="subtitle2" components="div">
                            Area of Expertise
                          </Typography>
                        }
                        secondary={
                          <>
                            <Typography variant="caption" components="block">
                              {exp.expertise.join(", ")}
                            </Typography>
                            {otherExpertise && <Typography variant="caption" display="block">
                              Other expertise: {otherExpertise}
                            </Typography>}

                          </>
                        }
                      />
                    </ListItem>
                  </List>
                ))}
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      </Grid>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
      >
        {mode === "add" && (
          <form autoComplete="off" onSubmit={handleSubmit(submitResults)}>
            <DialogTitle>Add Area of Expertise</DialogTitle>
            <DialogContent dividers={true} style={{ width: '500px'}}>
              <Grid
                container
                spacing={2}
                justifyContent="center"
                alignItems="center"
                style={{ padding: "20px" }}
              >
                <Grid item xs={12}>
                  <Controller
                    name="expertise"
                    control={control}
                    rules={{ required: true }}
                    render={({ field: { onChange } }) => {
                      return (
                        <Select
                          error={!!errors.expertise}
                          options={areasOfExpertise}
                          placeholder="Start typing your expertise"
                          noOptionsMessage={() =>
                            "The mentioned role isn't available"
                          }
                          isClearable
                          isMulti
                          isSearchable
                          fullWidth
                          helperText={
                            errors?.expertise ? errors.expertise?.message : ""
                          }
                          onChange={handleOnChange}
                          value={areasOfExpertise.filter((option) =>
                            selectedExpertise.includes(option.value)
                          )}
                          styles={{
                            menuPortal: (base) => ({
                              ...base,
                              zIndex: 9999,
                            }),
                            control: (base) => ({
                              ...base,
                              minHeight: 70,
                            }),
                          }}
                          menuPortalTarget={document.body} // Render the menu outside the current DOM hierarchy
                        />
                      );
                    }}
                  />
                </Grid>
                {selectedExpertise.includes("other") && (
                  <Grid item xs={12}>
                    <TextField
                      label="Other Expertise"
                      value={otherExpertise}
                      onChange={handleOtherExpertiseChange}
                      fullWidth
                    />
                  </Grid>
                )}
              </Grid>
            </DialogContent>
            <DialogActions>
              <Grid
                container
                spacing={2}
                style={{ margin: "10px" }}
                justifyContent="flex-end"
              >
                <Grid item xs={12}>
                  <Stack alignItems="right" direction="row" spacing={3}>
                    <Button
                      sx={{ borderRadius: 10 }}
                      variant="contained"
                      startIcon={<SaveIcon />}
                      type="submit"
                    >
                      Save
                    </Button>
                    <Button
                      sx={{ borderRadius: 10 }}
                      variant="contained"
                      startIcon={<CancelIcon />}
                      onClick={handleClose}
                    >
                      Cancel
                    </Button>
                  </Stack>
                </Grid>
              </Grid>
            </DialogActions>
          </form>
        )}
        {mode === "edit" && (
          <form>
            <DialogTitle>Edit/Remove Area of Expertise</DialogTitle>
            <DialogContent dividers={true}>
              <Grid
                container
                spacing={2}
                justifyContent="center"
                alignItems="center"
                style={{ marginTop: "5px" }}
              >
                <Grid item xs={12}>
                  {expertise?.map((exp) => (
                    <List key={exp._id} style={{ padding: "0px" }}>
                      <ListItem
                        style={{ paddingLeft: "10px" }}
                        secondaryAction={
                          <Stack
                            alignItems="flex-end"
                            direction="row"
                            paddingBottom="15px"
                          >
                            <IconButton
                              aria-label="edit"
                              onClick={() => handleEdit(exp._id, "editnew")}
                              style={{ margin: "0px", padding: "0px" }}
                            >
                              {/* <EditIcon color="primary" /> */}
                            </IconButton>
                            <IconButton
                              aria-label="delete"
                              onClick={() => handleRemove(exp._id)}
                              style={{ margin: "0px", padding: "0px" }}
                            >
                              <DeleteIcon style={{ color: red[400] }} />
                            </IconButton>
                          </Stack>
                        }
                      >
                        <ListItemText
                          style={{ paddingRight: "20px", margin: "0px" }}
                          primary={
                            <Typography variant="subtitle2" component="div">
                              Expertise
                            </Typography>
                          }
                          secondary={
                            <>
                              <Typography variant="caption" display="block">
                                {exp.expertise.join(", ")}
                              </Typography>
                              {otherExpertise && <Typography variant="caption" display="block">
                                Other expertise: {otherExpertise}
                              </Typography>}
                            </>
                          }
                        />
                      </ListItem>
                    </List>
                  ))}
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions>
              <Grid
                container
                spacing={2}
                style={{ margin: "10px" }}
                justifyContent="flex-end"
              >
                <Grid item xs={12}>
                  <Stack alignItems="right" direction="row" spacing={3}>
                    <Button
                      sx={{ borderRadius: 10 }}
                      variant="contained"
                      startIcon={<CancelIcon />}
                      onClick={handleClose}
                    >
                      Cancel
                    </Button>
                  </Stack>
                </Grid>
              </Grid>
            </DialogActions>
          </form>
        )}

        {mode === "editnew" && (
          <form
            autoComplete="off"
            onSubmit={() => {
              submitEditResults();
            }}
          >
            <DialogTitle>Edit Education</DialogTitle>
            <DialogContent dividers={true}>
              {renderSingleElement()}
            </DialogContent>
            <DialogActions>
              <Grid
                container
                spacing={2}
                style={{ margin: "10px" }}
                justifyContent="flex-end"
              >
                <Grid item xs={12}>
                  <Stack alignItems="right" direction="row" spacing={3}>
                    <Button
                      sx={{ borderRadius: 10 }}
                      variant="contained"
                      startIcon={<SaveIcon />}
                      type="submit"
                    >
                      Save
                    </Button>
                    <Button
                      sx={{ borderRadius: 10 }}
                      variant="contained"
                      startIcon={<CancelIcon />}
                      onClick={handleClose}
                    >
                      Cancel
                    </Button>
                  </Stack>
                </Grid>
              </Grid>
            </DialogActions>
          </form>
        )}
      </Dialog>
    </div>
  );
};

export default Expertise;